import type { IconProps } from "./types";

export function CircleXBold({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
      ? color
      : `var(--${color})`;

  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM13.4648 6.53516C13.1134 6.18368 12.5429 6.18368 12.1914 6.53516L10 8.72656L7.80859 6.53516C7.45712 6.18368 6.88663 6.18368 6.53516 6.53516C6.18372 6.88663 6.18369 7.45713 6.53516 7.80859L8.72656 10L6.53516 12.1914C6.18368 12.5429 6.18368 13.1134 6.53516 13.4648C6.88663 13.8163 7.45713 13.8163 7.80859 13.4648L10 11.2734L12.1914 13.4648C12.5429 13.8163 13.1134 13.8163 13.4648 13.4648C13.8163 13.1134 13.8163 12.5429 13.4648 12.1914L11.2734 10L13.4648 7.80859C13.8163 7.45713 13.8163 6.88663 13.4648 6.53516Z"
        fill={currentColor}
        transform="translate(2 2)"
      />
    </svg>
  );
}
